module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.added.positivePayout) ? _c('p', [_vm._v("\n    Bei einem unveränderten Basiswertkurs kommt es zu einer\n    Rückzahlung zum Nennbetrag von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.product.specific.notional, 'EUR'))
    }
  }), _vm._v(" zuzüglich einer\n    Zahlung eines Kupons in Höhe von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.percent(_vm.product.figures.couponTotal))
    }
  }), _vm._v("\n    am "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.date(_vm.product.common.payDate))
    }
  }), _vm._v(".\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.added.positivePayout && _vm.added.physical) ? _c('p', [_vm._v("\n    Bei einem unveränderten Basiswertkurs erhält der Wertpapierinhaber am Ende der Laufzeit eine Lieferung von\n    Aktien des Basiswertes. Die Anzahl der zu liefernden Aktien ergibt sich durch das Bezugsverhältnis. Bruchteile\n    von Aktien werden in bar zurückgezahlt (Ausgleichszahlung). Zuzüglich erhält er eine\n    Zahlung eines Kupons in Höhe von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.percent(_vm.product.figures.couponTotal))
    }
  }), _vm._v("\n    am "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.date(_vm.product.common.payDate))
    }
  }), _vm._v(".\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.added.positivePayout && !_vm.added.physical) ? _c('p', [_vm._v("\n    Bei einem unveränderten Basiswertkurs erfolgt eine Zahlung in Höhe des Marktpreises zuzüglich einer\n    Zahlung eines Kupons in Höhe von "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.percent(_vm.product.figures.couponTotal))
    }
  }), _vm._v("\n    am "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.date(_vm.product.common.payDate))
    }
  }), _vm._v(". In diesem Fall treten Verluste für\n    das eingesetzte\n    Kapital auf.\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16991777"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/factsheet/payback/PaybackReverse.vue
// module id = 658
// module chunks = 0